import { useState } from "react";
import { HomeTabWrapper } from "./styles";
import Tab from "./tab";
import TabMenu from "./tab-menu";
export enum TabType {
  PUB = "PUB",
  COMMUNITY = "COMMUNITY",
}

const HomeTab = () => {
  const [tab, setTab] = useState<TabType>(TabType.PUB);
  return (
    <HomeTabWrapper>
      <Tab tab={tab} setTab={setTab} />
      <TabMenu tab={tab} setTab={setTab} />
    </HomeTabWrapper>
  );
};

export default HomeTab;
